export const GTM_CONTENTSQUARE_TRIGGER = 'CS_event'

export const csIds = {
    navigation: {
        home: 'home-nav',
        alleSpil: 'alle-spil-nav',
        tilDig: 'til-dig-nav',
        liveCasino: 'live-casino-nav',
        aktuelt: 'aktuelt-nav',
    },
    header: {
        login: 'header-login-btn',
        signup: 'header-signup-btn',
        deposit: 'header-deposit-btn',
        burgerMenu: 'header-burger-menu',
        searchIcon: 'header-search-icon',
    },
    mobileBottom: {
        login: 'mobile-login-btn',
        signup: 'mobile-signup-btn',
    },
    gamePopup: {
        playBtn: 'game-popup-play-btn',
        tryBtn: 'game-popup-try-btn',
        favoriteBtn: 'game-popup-favorite-btn',
        addFavorite: 'game-popup-add-favorite',
        removeFavorite: 'game-popup-remove-favorite',
    },
    gameCard: {
        favoriteBtn: 'game-card-favorite-btn',
        addFavorite: 'game-card-add-favorite',
        removeFavorite: 'game-card-remove-favorite',
        infoBtn: 'game-card-info-btn',
    },
    highlights: {
        content: 'highlights-content',
        readMore: 'read-more',
    },
    sliders: {
        sliderShowMore: 'slider-show-more',
        sliderNextBtn: 'slider-next-btn',
        sliderPrevBtn: 'slider-prev-btn',
    },
    homepage: {
        search: 'search',
    },
    allGamesPage: {
        filterActionBtn: 'filter-action-btn',
    },
    footer: {
        stopspillet: 'footer-stopspillet',
        ludomani: 'footer-ludomani',
        rofus: 'footer-rofus',
    },
    sidebar: {
        menuItem: 'sidebar-menu-item',
        appDownload: 'sidebar-app-download',
    },
}
